/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyConsumableBillItem from './pharmacy-consumable-bill-item';
import PharmacyConsumableBillItemDetail from './pharmacy-consumable-bill-item-detail';
import PharmacyConsumableBillItemUpdate from './pharmacy-consumable-bill-item-update';
import PharmacyConsumableBillItemDeleteDialog from './pharmacy-consumable-bill-item-delete-dialog';

const PharmacyConsumableBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyConsumableBillItem />} />
    <Route path="new" element={<PharmacyConsumableBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyConsumableBillItemDetail />} />
      <Route path="edit" element={<PharmacyConsumableBillItemUpdate />} />
      <Route path="delete" element={<PharmacyConsumableBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyConsumableBillItemRoutes;
